import {Component, Vue} from 'vue-property-decorator'
import {menuBtn} from '@/utils/menu_level2_button'
import {formatDate} from '@/utils/timeFilter'
import {getMessageRemindById } from '@/api/message'



@Component({})
export default class ClassRemind extends Vue {

    infoData: any = {}

    status: string
    approvalStatus: number = null
    type = ''
    // newOrderData: any = []
    types = ""
    loading = false

    created() {
        //  获取地址栏里的参数
        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getMsgData(recordId)

    }

    menuBtn = menuBtn
    formatDate = formatDate

    // 获取数据
    async getMsgData(id) {
        this.loading = true
        await getMessageRemindById({id: id}).then((data: any)=>{
            this.infoData = data.result.messageRemindInfo
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })

    }

}
